import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthenticationQuery } from '../state/authentication.query';
import { SharedUrls } from '../../shared/constants/shared.constants';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LayoutQuery } from '../../layout/state/layout.query';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public authenticationQuery: AuthenticationQuery, private layoutQuery: LayoutQuery, private router: Router) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (request.url.includes('/connect/token')) {
      // If it's the login request, do not add any headers and proceed.
      return next.handle(request);
    }
    if (this.authenticationQuery.tokenInfo) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authenticationQuery.tokenInfo.access_token}`,
          'Accept-Language': this.layoutQuery.layoutState.language.locale,
        }
      });
    }

    return next.handle(request).pipe(catchError(error => {
      if (error.status === 401) {
        this.router.navigate([SharedUrls.Login]);
      }

      return throwError(error);
    }));
  }
}
